<template>
  <v-container fill-height pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <span class="hidden-sm-and-up">Welcome, {{ username }}</span>
          <v-spacer></v-spacer>
          <span>{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <v-btn color="success darken-3" @click="viewReports">View Reports</v-btn>
        <template>
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <div>
                  <h3 class="font-weight-regular">MERCHANT LIST</h3>
                  <h4
                    class="font-weight-light"
                  >{{ months[getDate.getMonth()] }} - {{ count }} locations</h4>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="merchantLocations"
              :pagination.sync="pagination"
              :search="search"
              :loading="loading"
              item-key="id"
            >
              <template slot="items" slot-scope="props">
                <tr class="pointer" @click="toroute(props.item.id)">
                  <td>
                    <h3 class="font-weight-regular">{{ props.item.merchant_name }}</h3>
                    <h4 class="font-weight-light" v-text="props.item.address"></h4>
                  </td>
                  <td>{{ props.item.area }}</td>
                  <td class="text-xs-center primary--text">{{ frequencies[props.item.visitation] }}</td>
                  <td class="text-xs-center">{{ props.item.visits_this_month }}</td>
                  <td class="text-xs-center">
                    <img src="@/assets/star.png" v-if="props.item.emergency_visit" alt="star">
                  </td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Your search for "{{ search }}" merchant has no results.</v-alert>
            </v-data-table>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AppLayout from "../../layouts/app"
import utils from "@/common/utils"
import { mapState, mapGetters, mapActions } from "vuex"
import { FETCH_MERCHANT_LOCATIONS } from "@/store/actions/merchant"

export default {
  name: "MerchantListPage",
  data() {
    return {
      getDate: new Date(),
      search: "",
      pagination: {
        sortBy: "emergency_visit",
        descending: true,
        rowsPerPage: -1
      },
      loading: false,
      headers: [
        {
          text: "Merchant",
          align: "left",
          value: "merchant_name"
        },
        { text: "Area", value: "area" },
        { text: "Frequency", value: "visitation" },
        {
          text: "Visits this month",
          align: "right",
          value: "visits_this_month"
        },
        { text: "Star", sortable: true, value: "emergency_visit" }
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      sorts: ["Importance", "Frequent Visits", "Alphabetically"]
    }
  },
  computed: {
    ...mapState({
      merchantLocations: state => state.merchant.merchantLocations,
      count: state => state.merchant.merchantLocationsCount
    }),
    username() {
      return this.$store.getters.getProfile.first_name
    },
    frequencies: function() {
      const solu = utils.VISITATION_CHOICES.reduce((ret, cur) => {
        ret[cur.value] = cur.name
        return ret
      }, {})
      return solu
    }
  },
  methods: {
    alert(name) {
      alert(name)
    },
    toroute(location_id) {
      this.$router.push(`/marshal/feedback/${location_id}`)
    },
    viewReports() {
      this.$router.push(`/marshal/reports/`)
    },
  },
  created() {
    this.$emit("update:layout", AppLayout)
  },
  mounted() {
    this.$store.dispatch(FETCH_MERCHANT_LOCATIONS)
  }
}
</script>

<style>
.merchant-header {
  background: rgba(0, 0, 0, 0.1)
}
table.v-table thead td:not(:nth-child(1)),
table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)),
table.v-table tbody th:not(:nth-child(1)),
table.v-table thead td:first-child,
table.v-table tbody td:first-child,
table.v-table tbody th:first-child {
  padding: 10px !important
}
.pointer {
  cursor: pointer
}
</style>

